import React, { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  useNavigate,
} from "react-router-dom";

import LoginView from "../views/LoginView/LoginView";
import { Typography } from "@mui/material";
import RegisterView from "../views/RegisterView/RegisterView";
import ManagerLoginView from "../views/ManagerLoginView/ManagerLoginView";
import UserPasswordResetView from "../views/UserPasswordResetView/UserPasswordResetView";
import ManagerPasswordResetView from "../views/ManagerPasswordResetView/ManagerPasswordResetView";
import CaseProgressView from "../views/CaseProgressView/CaseProgressView";
import NotFoundView from "../views/NotFoundView/NotFoundView";
import IntakeView from "../views/IntakeView/IntakeView";
import FinishUserAccountView from "../views/FinishUserAccountView/FinishUserAccountView";
import VerifyUserView from "../views/VerifyUserView/VerifyUserView";

const Redir = (props: { to: string }) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(props.to);
  });

  return (
    <>
      <Typography variant="h3">Redirecting...</Typography>
    </>
  );
};

const DefaultRouter = createBrowserRouter(
  [
    {
      path: "/",
      element: <LoginView />,
    },
    {
      path: "/manager-login",
      element: <ManagerLoginView />,
    },
    {
      path: "/login",
      element: <LoginView />,
    },
    {
      path: "/register",
      element: <RegisterView />,
    },
    {
      path: "/reset-password",
      element: <UserPasswordResetView />,
    },
    {
      path: "/manager-reset-password",
      element: <ManagerPasswordResetView />,
    },
    {
      // Partner case link. Registered in both routers so it opens the same whether or not the
      // visitor happens to have a staff session — a referral partner has no login at all.
      path: "/case/:token",
      element: <CaseProgressView />,
    },
    {
      // Public intake. The path carries the plan and nothing else — no personal data reaches a URL
      // an analytics script can read. These are the six buttons Ken repoints on the advertising
      // site, e.g. /non-cdl/best.
      //
      // Listed per product rather than as /:product/:tier, which would match any two-segment path
      // in the app and answer for routes that do not exist.
      path: "/non-cdl/:tier",
      element: <IntakeView />,
    },
    {
      path: "/cdl/:tier",
      element: <IntakeView />,
    },
    {
      path: "/finish-account-creation",
      element: <FinishUserAccountView />,
    },
    {
      path: "/verify-account",
      element: <VerifyUserView />,
    },
    {
      path: "*",
      element: <NotFoundView />,
    },
  ],
  {}
);
export default DefaultRouter;